import { SyntheticEvent, useState } from "react";

export interface ModalState<T> {
  open: boolean;
  editObject?: T;
}

/**
 * Hook for modal state
 * @param entityTitle title in Croatian, genitiv case
 * @param useTitleOnly flag if we want to use title without prefixes
 * @T generic TypeScript type for the editObject
 */
export const useModalState = <T>() => {
  const [modalState, setModalState] = useState<ModalState<T>>({
    open: false,
    editObject: undefined,
  });

  // if passed object doesn't have .target attribute, it is a Backend entity (not an event)
  const handleOpenModal = (editObject?: T) => {
    document.documentElement.classList.add("is-modal-opened");
    const isEditObjectAnEntity = (editObject as unknown as SyntheticEvent)?.target === undefined;
    setModalState({ open: true, editObject: isEditObjectAnEntity ? editObject : undefined });
  };
  const handleCloseModal = () => {
    document.documentElement.classList.remove("is-modal-opened");
    setModalState({ open: false, editObject: undefined });
  };

  return { modalState, handleOpenModal, handleCloseModal };
};
